import { useState } from 'react';
import { ViewId } from '~/shared/utils';
import { useIntl } from 'react-intl';
import {
  CaptionButton,
  IconWithCaptionButton,
} from '~/shared/components/ui/Button';
import { GetMessageWithIntl } from '~/shared/components';
import { getGenerallyIconElement } from '~/shared/components/parts/Button/GenerallyIcons';

interface PublicConfirmationPanelItemProps {
  companyInfo?: string;
  evaluationIndex1?: string;
  evaluationIndex2?: string;
  evaluationIndex3?: string;
  evaluationIndex4?: string;
}

interface PublicConfirmationPanelFooterProps {
  onBack: () => void;
  onPublic: () => void;
}

const VIEW_ID: ViewId = 'OCP_PR_INPUT';
export const PublicConfirmationPanelItem = ({
  companyInfo,
  evaluationIndex1,
  evaluationIndex2,
  evaluationIndex3,
  evaluationIndex4,
}: PublicConfirmationPanelItemProps) => {
  const intl = useIntl();
  const [readMore, setReadMore] = useState(false);
  return (
    <>
      <div className="tab-info-body">
        <div className="description-area">
          <p className="title">
            {getGenerallyIconElement('unchecked')}
            入力内容の最終確認
          </p>
          <p className="text-box">
            <span className="text">
              以下の内容で他企業に公開されます。修正が必要な場合は戻るボタンで編集画面に戻ってください。
              <br />
              「公開する」ボタンをクリックすると、他企業に公開されます。クリックせずに終了すると、公開保留となり一時保存したデータから再開可能です。
              <br />
            </span>
          </p>
        </div>
        <div className="expandable-container-area">
          <div className="container-title">企業紹介</div>
          <div
            className={`expandable-container-text ${
              readMore ? 'is-expanded' : ''
            }`}
          >
            {companyInfo}
          </div>
          <IconWithCaptionButton
            name="readMore"
            iconType={readMore ? 'up' : 'down'}
            caption={readMore ? '詳細を閉じる' : 'もっと見る'}
            onClick={() => {
              readMore ? setReadMore(false) : setReadMore(true);
            }}
          />
        </div>
        <div className="description-container-area">
          <div className="description-container">
            <div className="container-title">得意な生産形態</div>
            <div className="container-text">{evaluationIndex1}</div>
          </div>
          <div className="description-container">
            <div className="container-title">品質保証・検査</div>
            <div className="container-text">{evaluationIndex2}</div>
          </div>
        </div>
        <div className="description-container-area">
          <div className="description-container">
            <div className="container-title">主要取引業界</div>
            <div className="container-text">{evaluationIndex3}</div>
          </div>
          <div className="description-container">
            <div className="container-title">技術・設備のポイント</div>
            <div className="container-text">{evaluationIndex4}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export const PublicConfirmationPanelFooterItem = ({
  onBack,
  onPublic,
}: PublicConfirmationPanelFooterProps) => {
  const intl = useIntl();
  return (
    <>
      <CaptionButton
        name="backBtn"
        caption={GetMessageWithIntl(intl, { id: 'return' })}
        className="btn"
        onClick={onBack}
        buttonType="basic"
      />
      <CaptionButton
        name="publicBtn"
        caption={GetMessageWithIntl(intl, { prefixId: VIEW_ID, id: 'public' })}
        className="btn"
        onClick={onPublic}
        buttonType="high"
      />
    </>
  );
};
